import { css } from "styled-components";

export const LOCALES_FONT_ASSISTANT = ["he"];
export const LOCALES_FONT_VIETNAMESE = ["vi"];
export const LOCALES_FONT_ARABIC = ["ar"];

export const getAssistantFontStyles = () => css`
  --dui-font-family: Assistant, Delivery, Verdana, sans-serif;
`;

export const getArabicFontStyles = () => css`
  --dui-font-family: "Delivery Arabic", Delivery, Verdana, sans-serif;
`;

export const getVietnameseFontStyles = () => css`
  --dui-font-family: "Delivery Vietnamese", Delivery, Verdana, sans-serif;
`;

// eslint-disable-next-line consistent-return
const getAdditionalFonts = (locale) => {
  const language = locale.split("-")[0]; // Extracting language part from the locale

  if (LOCALES_FONT_ASSISTANT.includes(language)) {
    // Apply Assistant font styles
    return getAssistantFontStyles();
  }

  if (LOCALES_FONT_ARABIC.includes(language)) {
    // Apply Arabic font styles
    return getArabicFontStyles();
  }

  if (LOCALES_FONT_VIETNAMESE.includes(language)) {
    // Apply Vietnamese font styles
    return getVietnameseFontStyles();
  }
};

export default (locale) => css`
  :root {
    ${getAdditionalFonts(locale)}
  }
`;
